// src/components/Breadcrumb.tsx
import { Link } from "react-router-dom";

interface Category {
  name?: string;
  slug?: string;
}

interface BreadcrumbProps {
  category?: Category;
  gameName?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ category, gameName }) => {
  return (
    <nav className="text-sm text-gray-400 mb-4 pt-4">
      <ul className="flex flex-wrap items-center gap-x-2 gap-y-2">
        {/* Home Icon */}
        <li className="flex items-center gap-1">
          <Link to="/casual-games" className="flex items-center hover:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13">
              <path
                fill="#999"
                d="M1.5 11.25h2.51V7.471q0-.288.195-.483a.66.66 0 0 1 .482-.195h2.625q.288 0 .483.195t.195.483v3.779h2.51V4.615a.2.2 0 0 0-.025-.104.3.3 0 0 0-.069-.083l-4.269-3.21A.2.2 0 0 0 6 1.169a.2.2 0 0 0-.137.05l-4.27 3.21a.3.3 0 0 0-.068.083.2.2 0 0 0-.025.104zm-1.125 0V4.615a1.35 1.35 0 0 1 .542-1.084L5.187.314q.354-.27.812-.27.457 0 .814.27l4.27 3.217q.255.186.398.474.144.289.144.61v6.635q0 .46-.332.793a1.08 1.08 0 0 1-.793.332H7.543a.66.66 0 0 1-.483-.195.66.66 0 0 1-.195-.483V7.918h-1.73v3.779a.66.66 0 0 1-.195.483.66.66 0 0 1-.483.195H1.5q-.46 0-.793-.332a1.08 1.08 0 0 1-.332-.793"
              />
            </svg>
          </Link>
        </li>

        {/* Arrow */}
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10">
            <path
              fill="#737373"
              d="M4.416 5 .648 1.234a.499.499 0 0 1 .008-.71q.149-.15.355-.149.205 0 .355.149L5.194 4.36q.136.135.201.303A.9.9 0 0 1 5.461 5a.92.92 0 0 1-.267.64L1.36 9.476q-.15.15-.351.145a.5.5 0 0 1-.351-.153.48.48 0 0 1-.15-.354q0-.207.15-.355z"
            />
          </svg>
        </li>

        {/* Category */}
        <li className="flex items-center gap-1">
          <Link to={`/category/${category?.slug || category?.name?.toLowerCase()}`} className="hover:text-white">
            {category?.name || "-"}
          </Link>
        </li>

        {/* Arrow */}
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10">
            <path
              fill="#737373"
              d="M4.416 5 .648 1.234a.499.499 0 0 1 .008-.71q.149-.15.355-.149.205 0 .355.149L5.194 4.36q.136.135.201.303A.9.9 0 0 1 5.461 5a.92.92 0 0 1-.267.64L1.36 9.476q-.15.15-.351.145a.5.5 0 0 1-.351-.153.48.48 0 0 1-.15-.354q0-.207.15-.355z"
            />
          </svg>
        </li>

        {/* Current Game */}
        <li className="text-white font-medium">{gameName || "-"}</li>
      </ul>
    </nav>
  );
};

export default Breadcrumb;
